import { isMobileView } from "../../helpers/layoutUtils.js";
var MIN_SIGNING_FIELD_FONT_SIZE = 10;
var MAX_SIGNING_FIELD_FONT_SIZE = 32;
var MIN_TEXT_FIELD_FONT_SIZE = 7;
var MAX_TEXT_FIELD_FONT_SIZE = 11;
var TEXT_FIELD_TEXT_WIDTH_BUFFER = 8; // This line height ensures that what is displayed on the front end matches as
// close as possible with the printed PDF.

var LINE_HEIGHT = 1.4; // Calculate font size for the field based on the bounding and content
// dimensions and the allowable min and max for the type of field.

var scaleFontSize = function scaleFontSize(bounding, content, maxSize, minSize) {
  var signingField = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (!bounding || !content) return undefined;
  var boundingWidth = bounding.offsetWidth;
  var boundingHeight = bounding.offsetHeight;
  var contentWidth = content.offsetWidth;
  var contentHeight = content.offsetHeight;

  if (isMobileView()) {
    maxSize = Math.min(Math.floor(boundingHeight / 2), maxSize);
    minSize = Math.min(Math.floor(boundingHeight / 2), minSize);
  }

  var currentFontSize = window.getComputedStyle(bounding, null).getPropertyValue('font-size'); // Determine the max font size that will fit in the field based on the
  // fields bounding and content dimensions.

  var textWidthBuffer = signingField ? 0 : TEXT_FIELD_TEXT_WIDTH_BUFFER;
  var widthFontSize = parseFloat(currentFontSize) * boundingWidth / (contentWidth + textWidthBuffer);
  var heightFontSize = parseFloat(currentFontSize) * boundingHeight / contentHeight;
  var maxCalculatedFontSize = Math.min(widthFontSize, heightFontSize);
  var fontSize = Math.max(Math.min(maxCalculatedFontSize, maxSize), minSize);
  return Math.floor(fontSize);
};

var scaleMultilineTextFontSize = function scaleMultilineTextFontSize(bounding) {
  if (!bounding) return undefined;
  var maxSize = MAX_TEXT_FIELD_FONT_SIZE;
  var minSize = MIN_TEXT_FIELD_FONT_SIZE;
  var newFontSize;

  for (var fontSize = minSize; fontSize <= maxSize; fontSize++) {
    // Temporarily set the font size on the element to test if the text will
    // overflow at that font size.
    bounding.style.fontSize = "".concat(fontSize, "px");

    if (bounding.scrollHeight <= bounding.offsetHeight) {
      newFontSize = fontSize;
    } else {
      break;
    }
  }

  if (newFontSize) bounding.style.fontSize = "".concat(newFontSize, "px");
  return newFontSize;
};

var scaleTextFont = function scaleTextFont(bounding, content) {
  return scaleFontSize(bounding, content, MAX_TEXT_FIELD_FONT_SIZE, MIN_TEXT_FIELD_FONT_SIZE);
};

var scaleSigningFont = function scaleSigningFont(bounding, content) {
  return scaleFontSize(bounding, content, MAX_SIGNING_FIELD_FONT_SIZE, MIN_SIGNING_FIELD_FONT_SIZE, true);
};

var textOverflowHelper = function textOverflowHelper(bounding, content, textBuffer) {
  if (!bounding || !content) return true; // Unless the font size is at the minimum, we don't need to worry about text
  // overflow. We will let autoscaling do its job.

  var currentFontSize = window.getComputedStyle(bounding, null).getPropertyValue('font-size');
  if (parseInt(currentFontSize, 10) !== MIN_TEXT_FIELD_FONT_SIZE) return false;
  return content.offsetWidth + textBuffer > bounding.offsetWidth;
};

var preventTypingForSingleLineTextField = function preventTypingForSingleLineTextField(bounding, content, currentValue, newValue) {
  // If the user is deleting text, we don't want to prevent them even if the
  // text is currently overflowing the field.
  if (currentValue.length > newValue.length) {
    return false;
  }

  return textOverflowHelper(bounding, content, TEXT_FIELD_TEXT_WIDTH_BUFFER);
};

var isTextOverflowing = function isTextOverflowing(bounding, content) {
  // Use a smaller buffer than preventTypingForSingleLineTextField so
  // that it returns false if the text is at the border
  return textOverflowHelper(bounding, content, 0);
}; // This function provides the padding-top style so that text field content is
// bottom aligned.


var inputPaddingTopStyle = function inputPaddingTopStyle(field) {
  // For fields with small heights on mobile this pushes the text too low, so
  // don't add padding for those fields.
  if (!field.fontSize || isMobileView() && field.height < 20) return '';
  return "padding-top: ".concat(field.height - field.fontSize, "px !important;");
};

export { LINE_HEIGHT, MAX_SIGNING_FIELD_FONT_SIZE, MAX_TEXT_FIELD_FONT_SIZE, MIN_SIGNING_FIELD_FONT_SIZE, MIN_TEXT_FIELD_FONT_SIZE, inputPaddingTopStyle, isTextOverflowing, preventTypingForSingleLineTextField, scaleFontSize, scaleMultilineTextFontSize, scaleSigningFont, scaleTextFont };